import { useEmblaCarousel } from "embla-carousel/react";
import React, { memo, useEffect, useRef } from 'react';
import BannerOddsOverlay from "./BannerOddsOverlay";
import { getBannerTargetWindow } from '../data/sport-utils';
import './EmblaCarousel.css';

const SLIDER_INTERVAL = 8000;

function EmblaCarousel(props) {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        skipSnaps: false
    });
    const perc = useRef(0);
    const progressRef = useRef(null);

    useEffect(() => {
        let progressInterval = null;

        if (emblaApi) {
            progressInterval = setInterval(() => {
                if (perc.current === 100) {
                    perc.current = 0;
                    emblaApi.scrollNext();
                } else {
                    perc.current++;
                }
                if (progressRef.current) {
                    progressRef.current.style.width = `${perc.current}%`;
                }
            }, (SLIDER_INTERVAL / 100));
            // Reset progress bar on slide change event
            emblaApi.on('select', () => {
                perc.current = 0;
            });
        }

        return () => {
            clearInterval(progressInterval);
        };
    }, [emblaApi]);

    return (
        <div className="embla" ref={emblaRef}>
            <div className="embla__container">
                {props.banners.map((banner, i) => (
                    <div className="embla__slide" key={i}>
                        <div className="embla__slide__inner">
                            <a href={banner.url} target={getBannerTargetWindow(banner.url)} >
                                <img className="embla__slide__img"
                                    src={banner.imageUrl}
                                    alt=""
                                />
                            </a>
                            {banner.avvData?.bet != null &&
                                <BannerOddsOverlay banner={banner} />
                            }
                            {banner.avvData == null && banner.text?.length > 0 &&
                                <div className="banner-overlay">
                                    <div className="banner-overlay-text-container">
                                        <span className="banner-overlay-title">{banner.text}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                ))}
            </div>
            {props.banners.length > 1 &&
                <div className="background-bar">
                    <div className="progress-bar" style={{width: '0%'}} ref={progressRef}></div>
                </div>
            }
        </div>
    );
}
    
export default memo(EmblaCarousel);